module.exports = {
    ROUTER_BASEURL:"/web/",//路由根目录baseUrl,
    BASE_URL:"/web/",//发布BaseUrl
}
